<template>
  <div>
    <div
      class="reappro reappro--mobile"
      v-if="$store.getters['auth/isRole']('ROLE_TECHNICIAN') == true"
    >
      <ReapproHeader @searchReappro="setSearchReappro"></ReapproHeader>
      <ProductFamilyList class="categories--reappro"></ProductFamilyList>
      <div class="reappro__products">
        <ProductReapproParam
          :item="item"
          v-for="item in filteredItems"
          :key="item.id"
          @reload="reloadItems()"
          @delete="deletedFromReappro(item.id)"
          @min="changeMin(item.id, item.min_stock)"
          @max="changeMax(item.id, item.max_stock)"
        ></ProductReapproParam>
      </div>
      <div class="reappro__btns" v-if="dataToSave == 1">
        <a href="" class="reappro__btn btn btn--valider" @click.prevent="showModalS = 1">
          <span class="btn__text">Sauvegarder</span>
          <img src="/static/img/pictos/valider.svg" class="btn__picto" alt="" />
        </a>
        <a href="" class="reappro__btn btn btn--delete" @click.prevent="showModalC = 1">
          <span class="btn__text">Annuler</span>
          <img src="/static/img/pictos/supprimer.svg" class="btn__picto" alt="" />
        </a>
      </div>
    </div>
    <ReapproModal
      v-if="showModalS == 1"
      @close="showModalS = 0"
      @reload="reloadItems()"
      :type="'param'"
      :items="items"
    ></ReapproModal>
    <ReapproModal
      v-if="showModalC == 1"
      @close="showModalC = 0"
      @reload="reloadItems()"
      :type="'cancel-param'"
      :items="items"
    ></ReapproModal>
  </div>
</template>

<script>
import ReapproHeader from "@/components/Reappro/ReapproHeader";
import ProductFamilyList from "@/components/ProductFamily/ProductFamilyList";
import ProductReapproParam from "@/components/Product/ProductReapproParam";
import ReapproModal from "@/components/Reappro/ReapproModal";

export default {
  name: "ReapproParam",
  data() {
    return {
      showModalS: 0,
      showModalC: 0,
      items: [],
      filteredItems: [],
      searchedWord: "",
      dataToSave: 0,
    };
  },
  created() {
    this.$store.dispatch("showLoader");
    this.$store.dispatch("vehicle/getMyVehicleStockAutoReappro").then(() => {
      this.items = [...this.$store.getters["vehicle/getMyVehicleStockAutoReappro"][0]];
      this.$store.dispatch("hideLoader");
    });
  },
  computed: {},
  mounted() {
    this.$store.dispatch("showLoader");
    this.$store.dispatch("vehicle/getMyVehicleStockAutoReappro").then(() => {
      this.getItems();
      this.$store.dispatch("hideLoader");
    });
  },
  methods: {
    setSearchReappro(searchedWord) {
      this.searchedWord = searchedWord;
      this.searchFilter(this.searchedWord);
    },
    searchFilter(s) {
      const self = this;
      const regex = new RegExp(s.toLowerCase().replace(/\s/g, ".*"), "gi");
      self.filteredItems = self.items.filter((i) => {
        return i.product.label.toLowerCase().match(regex);
      });
    },
    getItems() {
      const self = this;
      self.dataToSave = 0;

      self.filteredItems = self.items;
    },
    reloadItems() {
      this.$store.dispatch("showLoader");
      this.$store.dispatch("vehicle/getMyVehicleStockAutoReappro").then(() => {
        this.getItems();
        this.$store.dispatch("hideLoader");
      });
    },
    changeMin(id, min) {
      const self = this;
      this.dataToSave = 1;
    },
    changeMax(id, max) {
      this.dataToSave = 1;
    },
    deletedFromReappro(id) {
      this.items = this.items.filter((item) => item.id != id);
      this.getItems();
      this.dataToSave = 1;
    },
  },
  components: {
    ReapproHeader,
    ProductFamilyList,
    ProductReapproParam,
    ReapproModal,
  },
};
</script>


<style lang="scss" scoped>
@import "~@/assets/scss/_colors.scss";

::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: white;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $grisclair;
  border-radius: 20px;
  height: 5px;
}

.reappro {
  display: flex;
  &--mobile {
    flex-direction: column;
    .reappro__products {
      padding: 20px;
    }
    .imputation__text {
      margin-right: 5px;
    }
    .product {
      .imputation__selector {
        margin-left: 0;
      }
    }
  }
}

.reappro__btns {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: flex-end;
  margin-top: 20px;
  width: 100%;
  position: fixed;
  bottom: 0;
  height: 75px;
  z-index: 19;
  .reappro__btn {
    width: 50%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: center;
    height: 75px;
    color: white;
    outline: none;
    border-radius: 0;
    padding: 0 20px;
    img {
      width: 25px;
      margin-left: 5px;
    }
    span {
      font-size: 11px;
      font-family: "ClanProBold";
    }
    &.btn--valider {
      background-color: $vert;
      justify-content: space-between;
    }
    &.btn--delete {
      background-color: $color1;
      justify-content: space-between;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Reappro/ReapproParam.vue